// extracted by mini-css-extract-plugin
export default {"scrollbar":"Scrollbar_scrollbar__AVQHy","small":"Scrollbar_small__0xB8n"};